// Keep the order of roles in a top-down hierarchy, so we can use this for sorting where needed
export enum RoleName {
  Admin = 'admin',
  Manager = 'manager',
  TeamLead = 'team_lead',
  Employee = 'employee',
}

export type RoleScopeName =
  | 'admin'
  | 'can_create_projects'
  | 'hide_hourly_rate'
  | 'hide_internal_hourly_rate';

interface RoleScopes {
  name: RoleScopeName;
  display_name: string;
  description?: string;
  default: true | false;
  options: Array<true | false>;
}

export interface UserRole {
  id: number;
  name: RoleName;
  display_name: string;
  description: string;
  scopes: Array<RoleScopes>;
  default: boolean;
  allowed_to_invite: boolean;
}
